import { render, staticRenderFns } from "./gj-pagination.vue?vue&type=template&id=895cdab4&scoped=true&"
import script from "./gj-pagination.vue?vue&type=script&lang=js&"
export * from "./gj-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895cdab4",
  null
  
)

export default component.exports